// ModalAddRemoveColumn

const addColumn = (state) => {
  const num = state.columnNum + 1;
  const headers = [...state.headers];
  headers.splice(num, 0, "");

  const values = state.values;
  values.map((el) => {
    if (el.length + 1 < headers.length)
      el.splice(num - 1, 0, "");
    return el
  });

  const checkHeaders = headers.filter((el) => el === "").length
    ? false
    : true;

  const checkVaules = values.map(el => el.filter(i => i === "").length > 0).filter(ii => ii === true).length
    ? false
    : true;

  return {
    ...state,
    alertTable: false,
    alertStatus: null,
    headers,
    values,
    checkHeaders,
    checkVaules
  }
}

export default addColumn